import React, { useEffect, useRef, useState } from "react";
import { formatDistance, parseISO } from "date-fns";

import {
  getActiveProgramById,
  getGroupSession,
  updateGroupSession,
} from "../../services/ActivePrograms";
import { toast } from "react-toastify";
import { IoArrowBack } from "react-icons/io5";
import { AiFillEdit } from "react-icons/ai";
import { FiPlusCircle } from "react-icons/fi";
import { RiDeleteBin6Fill } from "react-icons/ri";

import "react-quill/dist/quill.snow.css";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import moment from "moment";
import BulletEditor from "../../commonComponent/BulletEditor";

const RateChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <AreaChart
        data={data}
        margin={{
          top: 10,
          right: 0,
          left: -25,
          bottom: 0,
        }}
      >
        <CartesianGrid
          strokeDasharray="3 1"
          stroke="#999B9C"
          vertical={false}
          horizontal={true}
        />
        {/* <XAxis dataKey="name" /> */}
        <YAxis />
        <Tooltip
          formatter={(value, name, props) => [value, name]}
          labelFormatter={(label, payload) => {
            // Show name from payload[0].payload
            if (payload && payload.length) {
              return payload[0].payload.name; // Replace 'name' with your key
            }
            return label;
          }}
        />
        <Area
          type="monotone"
          dataKey="value"
          strokeWidth={3}
          stroke="#4CC2B0"
          fill="#4CC2B0"
          fillOpacity={0.3}
        />
        <Area
          type="monotone"
          dataKey="value2"
          strokeWidth={3}
          stroke="#999B9C"
          fill="#999B9C"
          fillOpacity={0.3}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

const ConcernChart = ({ data }) => {
  const chartData = data.map((item, index) => ({
    name: String.fromCharCode(65 + index),
    Concern: parseInt(item.numberOfMembers),
  }));
  return (
    <ResponsiveContainer height={220} width="100%">
      <BarChart width={250} height={250} data={chartData}>
        <CartesianGrid strokeDasharray="3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Bar dataKey="Concern" fill="#1F7E78" />
      </BarChart>
    </ResponsiveContainer>
  );
};

const EditConcernsModal = ({ editConcern, handleEditConcerns }) => {
  const [concern, setConcern] = useState({
    concern: "",
    numberOfMembers: "",
  });

  useEffect(() => {
    setConcern({
      concern: editConcern?.concern ?? "",
      numberOfMembers: editConcern?.numberOfMembers ?? "",
    });
  }, [editConcern]);

  const handleChange = (e) => {
    setConcern((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleEditConcerns(editConcern.index, concern);
    setConcern({
      concern: "",
      numberOfMembers: "",
    });
    document.getElementById("closeEditConcernsModal").click();
  };

  return (
    <div
      className="modal fade"
      id="editConcernsModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Concerns</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeEditConcernsModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-7">
                  <label
                    htmlFor="concern"
                    className="form-label text-green fw-bold"
                  >
                    Concern
                  </label>
                </div>
                <div className="col-md-5">
                  <label
                    htmlFor="chiefComplaint"
                    className="form-label text-green fw-bold"
                  >
                    Number of Members
                  </label>
                </div>
                <div className="col-md-7 mt-3">
                  <input
                    type="text"
                    name="concern"
                    required
                    className="form-control bg-light"
                    placeholder="Concern"
                    onInput={handleChange}
                    value={concern.concern}
                  />
                </div>
                <div className="col-md-5 mt-3">
                  <div className="d-flex gap-4">
                    <input
                      type="number"
                      name="numberOfMembers"
                      id="numberOfMembers"
                      required
                      className="form-control bg-light"
                      onInput={handleChange}
                      value={concern.numberOfMembers}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white"
                >
                  Update Concern
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddConcernsModal = ({ handleAddConcerns }) => {
  const [concerns, setConcerns] = useState({
    concern: "",
    numberOfMembers: "",
  });

  const handleChange = (e) => {
    setConcerns((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddConcerns(concerns);
    setConcerns({
      concern: "",
      numberOfMembers: "",
    });
    document.getElementById("closeAddConcernsModal").click();
  };

  return (
    <div
      className="modal fade"
      id="addConcernsModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            {/* <h5 className="modal-title" id="exampleModalLabel">Modal title</h5> */}
            <h5 className="mb-0">Concerns</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeAddConcernsModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-7">
                  <label
                    htmlFor="chiefComplaint"
                    className="form-label text-green fw-bold"
                  >
                    Concern
                  </label>
                </div>
                <div className="col-md-5">
                  <label
                    htmlFor="chiefComplaint"
                    className="form-label text-green fw-bold"
                  >
                    Number of Members
                  </label>
                </div>
                <div className="col-md-7 mt-3">
                  <input
                    type="text"
                    name="concern"
                    className="form-control bg-light"
                    placeholder="Concern"
                    onInput={handleChange}
                    value={concerns.concern}
                    required
                  />
                </div>
                <div className="col-md-5 mt-3">
                  <input
                    type="number"
                    name="numberOfMembers"
                    className="form-control bg-light"
                    placeholder="Number of Members"
                    onInput={handleChange}
                    value={concerns.numberOfMembers}
                    required
                  />
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white"
                >
                  Add Concern
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddCarePlanModal = ({ handleAddCarePlan, carePlanList }) => {
  const [carePlan, setCarePlan] = useState({ _id: "", name: "" });
  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddCarePlan(carePlan);
    setCarePlan({ _id: "", name: "" });
    document.getElementById("closeAddCarePlanModal").click();
  };

  return (
    <div
      className="modal fade"
      id="addCarePlanModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Care Plans</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeAddCarePlanModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <select
                    name="duration"
                    id="duration"
                    className="form-select bg-light"
                    onChange={(e) =>
                      setCarePlan({
                        _id: e.target.value,
                        name: e.target.options[e.target.selectedIndex].text,
                      })
                    }
                    value={carePlan?._id}
                    required
                  >
                    <option value="">Select Care Plan</option>
                    {carePlanList.map((item, index) => (
                      <option value={item._id} key={index}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Add Care Plan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const EditHealthMetricModal = ({
  editHealthMetric,
  handleEditHealthMetric,
}) => {
  const [healthMetric, setHealthMetric] = useState(editHealthMetric);
  const handleSubmit = (e) => {
    e.preventDefault();
    handleEditHealthMetric(editHealthMetric.index, healthMetric);
    setHealthMetric({ _id: "", name: "", duration: "", frequency: "" });
    document.getElementById("closeEditMedicalHistoryModal").click();
  };

  return (
    <div
      className="modal fade"
      id="editMedicalHistoryModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Medical History</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeEditMedicalHistoryModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <input
                    type="text"
                    className="form-control bg-light"
                    placeholder="Enter Medical Condition"
                    value={healthMetric?.name}
                    onInput={(e) =>
                      setHealthMetric({
                        ...healthMetric,
                        name: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-12 mt-3">
                  <div className="d-flex gap-3 align-items-center">
                    <input
                      type="number"
                      className="form-control bg-light"
                      placeholder="Enter Duration"
                      value={healthMetric?.duration}
                      onInput={(e) =>
                        setHealthMetric({
                          ...healthMetric,
                          duration: e.target.value,
                        })
                      }
                    />
                    <select
                      name="frequency"
                      id="frequency"
                      className="form-select bg-light"
                      value={healthMetric?.frequency}
                      onChange={(e) =>
                        setHealthMetric({
                          ...healthMetric,
                          frequency: e.target.value,
                        })
                      }
                    >
                      <option value="years">Years</option>
                      <option value="months">Months</option>
                      <option value="weeks">Weeks</option>
                      <option value="days">Days</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Update Health Metric
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddHealthMetricModal = ({ handleAddHealthMetric, healthMetrics }) => {
  const healthMetricsList = [
    {
      _id: "bloodPressure",
      name: "Blood Pressure",
      code: "mmHg",
    },
    { _id: "respiratoryRate", name: "Respiratory Rate", code: "cycles/min" },
    { _id: "temperature", name: "Temperature", code: "°F" },
    { _id: "oxygenSaturation", name: "Oxygen Saturation", code: "%" },
    { _id: "heartRate", name: "Heart Rate", code: "beats/min" },
  ].filter((item) => !healthMetrics.find((metric) => metric.key === item._id));

  const [healthMetric, setHealthMetric] = useState({
    key: "",
    value: "",
    code: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddHealthMetric(healthMetric);
    setHealthMetric({
      key: "",
      value: "",
      code: "",
    });
    document.getElementById("closeAddHealthMetricModal").click();
  };

  return (
    <div
      className="modal fade"
      id="addHealthMetricModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Health Metric</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeAddHealthMetricModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <select
                    name="healthMetric"
                    id="healthMetric"
                    className="form-select bg-light"
                    onChange={(e) =>
                      setHealthMetric({
                        key: e.target.value,
                        value: e.target.options[e.target.selectedIndex].text,
                        code: healthMetricsList.find(
                          (item) => item._id === e.target.value
                        )?.code,
                      })
                    }
                    value={healthMetric?._id}
                    required
                  >
                    <option value="">Select Health Metric</option>
                    {healthMetricsList.map((item, index) => (
                      <option value={item._id} key={index}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Add Health Metric
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const EditCarePlanModal = ({
  editCarePlan,
  handleEditCarePlan,
  carePlanList,
}) => {
  const [carePlan, setCarePlan] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    handleEditCarePlan(editCarePlan.index, carePlan);
    setCarePlan("");
    document.getElementById("closeEditCarePlanModal").click();
  };

  return (
    <div
      className="modal fade"
      id="editCarePlanModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Care Plans</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeEditCarePlanModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <select
                    name="duration"
                    id="duration"
                    className="form-select bg-light"
                    onChange={(e) =>
                      setCarePlan({
                        _id: e.target.value,
                        name: e.target.options[e.target.selectedIndex].text,
                      })
                    }
                    value={editCarePlan?.carePlan?._id}
                    required
                  >
                    <option value="">Select Care Plan</option>
                    {carePlanList.map((item, index) => (
                      <option value={item._id} key={index}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Update Care Plan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

// export default BulletTextEditor;
function ViewSessionGroupNoteEdit({ setViewMode, state, member }) {
  const [programDetails, setProgramDetails] = useState({});
  const [editConcern, setEditConcern] = useState(null);
  const [editCarePlan, setEditCarePlan] = useState(null);
  const [editHealthMetric, setEditHealthMetric] = useState(null);

  const [concerns, setConcerns] = useState([]);
  const [carePlanList, setCarePlanList] = useState([]);
  const [carePlans, setCarePlans] = useState([]);

  const [assessmentComments, setAssessmentComments] = useState("");
  const [carePlanComments, setCarePlanComments] = useState("");
  const [objectives, setObjectives] = useState([]);

  const [duration, setDuration] = useState("");
  const [session, setSession] = useState(null);

  const [healthMetrics, setHealthMetrics] = useState([]);
  const [healthMetricsComments, setHealthMetricsComments] = useState("");

  const getProgram = async () => {
    try {
      const res = await getActiveProgramById(state?.programId);
      setProgramDetails(res?.data?.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const getSession = async () => {
    try {
      const res = await getGroupSession(state?._id, state?.programId);
      console.log("objectives", res?.data?.data.objectives);
      setSession(res?.data?.data);
      setCarePlanList(res?.data?.data?.carePlanList);
      if (res?.data?.data?.groupSession) {
        const userSession = res?.data?.data?.groupSession;
        setConcerns(userSession?.concerns ?? []);
        setCarePlans(userSession?.carePlans);
        setHealthMetrics(userSession?.healthMetrics);
        setObjectives(res?.data?.data?.objectives);
        setHealthMetricsComments(userSession?.healthMetricsComments ?? "");

        setAssessmentComments(userSession?.assessmentComments ?? "");
        setCarePlanComments(userSession?.carePlanComments ?? "");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getProgram();
    getSession();
  }, []);

  const handleSubmit = async (type) => {
    let parms = {};
    parms["programId"] = state?.programId;
    parms["sessionId"] = state?._id;
    // parms["userId"] = member?.user_id;

    parms["healthMetrics"] = healthMetrics;

    parms["healthMetricsComments"] = healthMetricsComments;
    parms["assessmentComments"] = assessmentComments;
    parms["carePlans"] = carePlans.map((item) => item._id);
    parms["carePlanComments"] = carePlanComments;
    parms["concerns"] = concerns;

    if (type === "saveLater") {
      parms["status"] = "draft";
    } else {
      parms["status"] = "completed";
    }

    try {
      const response = await updateGroupSession(parms);
      if (response.status === 200) {
        toast.success("Session Updated");
        setViewMode("sessionNotes");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddConcerns = (data) => {
    setConcerns((prev) => [...prev, data]);
  };
  const handleEditConcerns = (index, data) => {
    setConcerns((prev) => prev.map((item, i) => (i === index ? data : item)));
  };
  const handleDeleteConcerns = (index) => {
    setConcerns((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCarePlan = (data) => {
    setCarePlans((prev) => [...prev, data]);
  };
  const handleEditCarePlan = (index, data) => {
    setCarePlans((prev) => prev.map((item, i) => (i === index ? data : item)));
  };
  const handleDeleteCarePlan = (index) => {
    setCarePlans((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddHealthMetric = (data) => {
    setHealthMetrics((prev) => [...prev, data]);
  };
  const handleEditHealthMetric = (index, data) => {
    setHealthMetrics((prev) =>
      prev.map((item, i) => (i === index ? data : item))
    );
  };
  const handleDeleteHealthMetric = (index) => {
    setHealthMetrics((prev) => prev.filter((_, i) => i !== index));
  };

  const getDuration = () => {
    const dur =
      state?.startTime &&
      state?.endTime &&
      formatDistance(parseISO(state.endTime), parseISO(state.startTime));
    setDuration(dur);
  };
  useEffect(() => {
    getDuration();
  }, []);

  return (
    <div className="row column-gap-5">
      <div className="d-flex mt-2">
        <button
          className="btn btn-primary btn-custom-tag py-2 "
          onClick={() => setViewMode("sessionNotes")}
        >
          <IoArrowBack /> &nbsp;&nbsp;&nbsp; Back
        </button>
      </div>
      <div className="mt-4">
        <h5 className="fw-bold"> Group Session Note</h5>
        <div className="d-flex gap-2 align-items-center mt-4 justify-content-between">
          <h6 className="text-green mb-0 fw-bold">
            Program Title
            <span className="text-dark ms-3">
              {programDetails?.programName}
            </span>
          </h6>

          <h6 className="text-green mb-0 fw-bold">
            Facilitator{" "}
            <span className="text-dark ms-3">
              {session?.session?.createdBy}
            </span>
          </h6>
        </div>
        <div className="d-flex gap-2 align-items-center mt-4 justify-content-between">
          <h6 className="text-green mb-0 fw-bold">
            Encounter type{" "}
            <span className="text-dark ms-3">
              {programDetails?.programType}
            </span>
          </h6>
          <h6 className="text-green mb-0 fw-bold">
            Encounter Date{" "}
            <span className="text-dark ms-3">
              {moment(session?.session?.sessionDate).format("DD MMMM, YYYY")}
            </span>
          </h6>
          <h6 className="text-green mb-0 fw-bold">
            Duration{" "}
            <span className="text-dark ms-3">
              {
                Math.floor((new Date(session?.session?.endTime) - new Date(session?.session?.startTime)) / 60000)+" minutes"
              }
            </span>
          </h6>
        </div>
        <div className="d-flex gap-2 align-items-center mt-4 justify-content-between">
          <h6 className="text-green mb-0 fw-bold">
            Session Title
            <span className="text-dark ms-3">{session?.session?.title}</span>
          </h6>
          <h6 className="text-green mb-0 fw-bold">
            Number of Participants
            <span className="text-dark ms-3">
              {programDetails?.programMembers?.length}
            </span>
          </h6>
        </div>
      </div>

      <div className="mt-1 pt-2">
        <div className="bg-green px-3 py-2">
          <h6 className="text-white mb-0">Subjective</h6>
        </div>
        <div>
          <div className="d-flex gap-3 mt-3 w-100">
            <h6 className="text-green mb-0 text-nowrap fw-bold">
              Reported Concerns
            </h6>
            <div className="w-100">
              {concerns.map((item, index) => (
                <div
                  className="d-flex gap-3 align-items-center mb-2"
                  key={index}
                >
                  <h6 className=" mb-0 fw-bold">
                    {String.fromCharCode(65 + index)}
                  </h6>
                  <input
                    type="text"
                    className="form-control bg-light"
                    placeholder="Add Concern"
                    value={item.concern}
                    disabled
                  />

                  <h6 className="text-green mb-0 fw-bold">Number of Members</h6>

                  <input
                    type="text"
                    className="form-control bg-light w-25 "
                    value={item.numberOfMembers}
                    disabled
                  />
                  <div className="d-flex gap-1 align-items-center">
                    <button
                      className="btn btn-sm"
                      onClick={() => {
                        setEditConcern({ ...item, index });
                      }}
                      data-bs-toggle="modal"
                      data-bs-target="#editConcernsModal"
                    >
                      <AiFillEdit color="#1F7E78" size={18} />
                    </button>
                    <button
                      className="btn btn-sm"
                      onClick={() => handleDeleteConcerns(index)}
                    >
                      <RiDeleteBin6Fill color="#1F7E78" size={18} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            data-bs-toggle="modal"
            data-bs-target="#addConcernsModal"
            className="d-flex justify-content-start gap-2 align-items-center pointer my-2"
            onClick={() => {}}
          >
            <FiPlusCircle color="#1F7E78" size={18} />
            <span href="" className="fst-italic" style={{ fontSize: "16px" }}>
              Add Concerns
            </span>
          </div>
          <div className="mt-2 text-center">
            <div className="row mt-3">
              <div className="col-md-4 px-3 text-center d-flex align-items-center justify-content-end  ">
                <h6 className="text-green mb-0">% of participants</h6>
              </div>
              <div className="col-md-4 px-3 ">
                <ConcernChart data={concerns} />
                <h6 className="text-green">Concerns</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <div className="bg-green px-3 py-2">
          <h6 className="text-white mb-0">Objective</h6>
        </div>
        <h6 className="text-green mb-0 text-nowrap fw-bold mt-3">
          Group Health Metrics
        </h6>
        <div className="row mt-3 justify-content-center mx-1">
          {healthMetrics?.map((item, index) => (
            <div className="col-md-4 px-3 mb-4" key={index}>
              <h6 className=" text-muted mb-0">{item.value}</h6>
              <div className="d-flex justify-content-between align-items-center">
                <h6 className="text-green text-center d-block  mt-3">
                  {item.code}
                </h6>
                <div className="d-flex gap-2 align-items-center">
                  {/* <button
                    className="btn btn-sm"
                    // onClick={() => {
                    //   setEditComplaint({ ...item, index });
                    // }}
                    data-bs-toggle="modal"
                    data-bs-target="#editChiefComplaintModal"
                  >
                    <AiFillEdit color="#1F7E78" size={18} />
                  </button> */}
                  <button
                    className="btn btn-sm"
                    onClick={() => handleDeleteHealthMetric(index)}
                  >
                    <RiDeleteBin6Fill color="#1F7E78" size={18} />
                  </button>
                </div>
              </div>
              {item.value === "Blood Pressure" ? (
                <RateChart
                  data={objectives
                    .filter((obj) => obj[item.key].diastolic)
                    .map((obj) => {
                      return {
                        name: obj.name,
                        value: obj[item.key].diastolic,
                        value2: obj[item.key].systolic,
                      };
                    })}
                />
              ) : (
                <RateChart
                  data={objectives
                    .filter((obj) => obj[item.key])
                    .map((obj) => {
                      return { name: obj.name, value: obj[item.key] };
                    })}
                />
              )}
              <h6 className="text-muted text-center d-block  mt-3">Members</h6>
              {item.value === "Blood Pressure" && (
                <div className="my-2 text-center ">
                  <div className="d-flex gap-4 align-items-center justify-content-center">
                    <div className="d-flex gap-2 align-items-center">
                      <span
                        style={{
                          width: "20px",
                          height: "8px",
                          backgroundColor: "#4CC2B0",
                          borderRadius: "30%",
                        }}
                      ></span>
                      <span>Systolic</span>
                    </div>
                    <div className="d-flex gap-2 align-items-center">
                      <span
                        style={{
                          width: "20px",
                          height: "8px",
                          backgroundColor: "#999B9C",
                          borderRadius: "30%",
                        }}
                      ></span>
                      <span>Diastolic</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div
        data-bs-toggle="modal"
        data-bs-target="#addHealthMetricModal"
        className="d-flex justify-content-start gap-2 align-items-center pointer my-2"
        onClick={() => {}}
      >
        <FiPlusCircle color="#1F7E78" size={18} />
        <span href="" className="fst-italic" style={{ fontSize: "16px" }}>
          Add Health Metric
        </span>
      </div>
      <div className="mt-2 pt-2">
        <div className="">
          <span className="" style={{ fontWeight: "500" }}>
            Other Comments
          </span>
        </div>
        <div className="mt-2">
          <BulletEditor
            value={healthMetricsComments}
            setValue={setHealthMetricsComments}
          />
        </div>
      </div>
      <div className="mt-4">
        <div className="bg-green px-3 py-2">
          <h6 className="text-white mb-0">Assessment</h6>
        </div>
        <div className="mt-2 pt-2">
          <div className="">
            <span className="" style={{ fontWeight: "500" }}>
              Clinical Summary & Key Takeaways
            </span>
          </div>
          <div className="mt-2">
            <BulletEditor
              value={assessmentComments}
              setValue={setAssessmentComments}
            />
          </div>
        </div>
      </div>
      <div className="mt-4">
        <div className="bg-green px-3 py-2">
          <h6 className="text-white mb-0">Plan</h6>
        </div>
        <div
          data-bs-toggle="modal"
          data-bs-target="#addCarePlanModal"
          className="d-flex justify-content-start gap-2 align-items-center pointer my-3"
          onClick={() => {}}
        >
          <FiPlusCircle color="#1F7E78" size={18} />
          <span href="" className="fst-italic" style={{ fontSize: "16px" }}>
            Add Care Plan
          </span>
        </div>

        <div className="mt-2">
          {carePlans.map((item, index) => (
            <div className="d-flex gap-3 align-items-center mb-2" key={index}>
              <input
                type="text"
                className="form-control bg-light w-25"
                value={item.name}
                disabled
              />
              <div className="d-flex gap-1 align-items-center">
                <button
                  className="btn btn-sm"
                  onClick={() => {
                    setEditCarePlan({ carePlan: item, index });
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#editCarePlanModal"
                >
                  <AiFillEdit color="#1F7E78" size={18} />
                </button>
                <button
                  className="btn btn-sm"
                  onClick={() => handleDeleteCarePlan(index)}
                >
                  <RiDeleteBin6Fill color="#1F7E78" size={18} />
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-2 pt-2">
          <div className="">
            <span className="" style={{ fontWeight: "500" }}>
              Other Comments
            </span>
          </div>
          <div className="mt-2">
            <BulletEditor
              value={carePlanComments}
              setValue={setCarePlanComments}
            />
          </div>
        </div>
      </div>
      <div className="mt-4 d-flex justify-content-between">
        <button
          className="btn border py-2"
          onClick={() => setViewMode("sessionNotes")}
        >
          Cancel
        </button>
        <div className="d-flex gap-2">
          <button
            className="btn btn-custom-tag mb-0 py-2"
            onClick={() => handleSubmit("saveLater")}
          >
            Save for Later
          </button>
          <button
            className="btn btn-custom text-white py-2"
            onClick={() => handleSubmit("saveSessionNote")}
          >
            Save Session Note
          </button>
        </div>
      </div>
      <EditConcernsModal
        editConcern={editConcern}
        handleEditConcerns={handleEditConcerns}
      />
      <AddConcernsModal handleAddConcerns={handleAddConcerns} />
      <EditCarePlanModal
        editCarePlan={editCarePlan}
        handleEditCarePlan={handleEditCarePlan}
        carePlanList={carePlanList}
      />
      <AddCarePlanModal
        editCarePlan={editCarePlan}
        handleAddCarePlan={handleAddCarePlan}
        carePlanList={carePlanList}
      />
      <AddHealthMetricModal
        handleAddHealthMetric={handleAddHealthMetric}
        healthMetrics={healthMetrics}
      />
      <EditHealthMetricModal
        editHealthMetric={editHealthMetric}
        handleEditHealthMetric={handleEditHealthMetric}
      />
    </div>
  );
}

export default ViewSessionGroupNoteEdit;
